import { ActiveRound, RoundCancelReason } from "./Round";

export interface BetPush {
  id: string;
  free_bet_id?: string;
  success: SuccessBetEvent;
  cancel: CancelBetEvent;
  error: ErrorBetEvent;
}

export type ErrorBetEvent = Readonly<{ error_code: string }>;
export type CancelBetEvent = Readonly<{ cancel_reason: RoundCancelReason }>;
export type SuccessBetEvent = Readonly<{ status: string; update_at: string; state: ActiveRound }>;

export type BetEvent = SuccessBetResponse | ErrorBetResponse | CancelBetResponse;
export type BaseResponse = Readonly<{ id: string }>;

export type SuccessBetResponse = Readonly<{ type: BetEventType.S; updated_at: string }> & ActiveRound & BaseResponse;
export type ErrorBetResponse = Readonly<{ type: BetEventType.E; error_code: string }> & BaseResponse;
export type CancelBetResponse = Readonly<{ type: BetEventType.C; cancel_reason: RoundCancelReason }> & BaseResponse;

export enum BetEventType {
  S,
  C,
  E,
}
